import { updateTicker, rankTopics } from "@/mocks/hotTopics";

export default function UpdateBar() {
  // 榜单前 3 作为「此刻正热」入口
  const nowHot = rankTopics.slice(0, 3);
  const tickerItems = [...updateTicker, ...updateTicker];

  return (
    <section id="top" className="border-b border-background-200 bg-background-50">
      {/* —— 压顶更新条 —— */}
      <div className="flex items-center overflow-hidden border-b border-background-200 bg-background-100/80">
        <div className="z-10 flex h-9 shrink-0 items-center gap-2 bg-primary-500 px-3 text-background-50 sm:px-4">
          <span className="h-1.5 w-1.5 rounded-full bg-background-50 animate-pulse-dot" />
          <span className="whitespace-nowrap text-xs font-semibold">实时更新</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-ticker flex w-max items-center gap-8 whitespace-nowrap py-2.5 pl-4 text-xs text-foreground-600">
            {tickerItems.map((item, idx) => (
              <span key={idx} className="flex items-center gap-2">
                <i className="ri-fire-fill text-xs text-primary-500" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* —— 首屏入口台：更新台信息 + 此刻正热 —— */}
      <div className="mx-auto grid w-full max-w-6xl gap-8 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-[1.4fr_1fr]">
        <div>
          <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-50 px-3 py-1 text-xs font-medium text-accent-700">
            <i className="ri-flashlight-line text-sm" />
            51嘿料 · 专题合集浏览
          </p>
          <h1 className="font-serif text-3xl font-black leading-snug tracking-tight text-foreground-950 md:text-5xl">
            围观大家正在<span className="text-primary-600">吵什么</span>
            <br />
            <span className="text-foreground-700">又挺什么</span>
          </h1>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            实时感受 51嘿料 相关话题的讨论热度。这里聚合网友观点、舆论风向与争议焦点，用标题 + 短摘要的合集方式，
            把最值得看的讨论一次性铺到你面前。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#fights"
              className="flex h-11 items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              看今日争议焦点
              <i className="ri-arrow-right-line ml-2" />
            </a>
            <a
              href="#forums"
              className="flex h-11 items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              进入热议分区
            </a>
          </div>

          {/* 轻量化状态行 */}
          <dl className="mt-8 flex flex-wrap gap-x-10 gap-y-4 border-t border-background-200 pt-5">
            {[
              ["11,641", "收录热议话题"],
              ["3.2亿+", "累计围观人次"],
              ["86", "当前讨论分区"],
            ].map(([num, label]) => (
              <div key={label}>
                <dt className="sr-only">{label}</dt>
                <dd className="font-serif text-2xl font-bold text-foreground-950">{num}</dd>
                <dd className="mt-1 text-xs text-foreground-500">{label}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 此刻正热入口 */}
        <div className="rounded-xl border border-background-200 bg-background-50 p-5">
          <div className="mb-4 flex items-center justify-between">
            <h2 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
              <i className="ri-bubble-chart-line text-primary-500" />
              此刻正热 · 直达
            </h2>
            <span className="flex items-center gap-1 text-xs text-accent-700">
              <i className="ri-flashlight-fill" />
              热度在线
            </span>
          </div>
          <div className="flex flex-col gap-3">
            {nowHot.map((t) => (
              <a
                key={t.rank}
                href="#rank"
                className="group-card rounded-lg border border-background-200 bg-background-100/70 p-3.5"
              >
                <div className="flex items-start gap-3">
                  <span
                    className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-serif text-sm font-black ${
                      t.rank === 1 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {t.rank}
                  </span>
                  <div className="min-w-0">
                    <p className="line-clamp-1 text-sm font-semibold text-foreground-900">{t.title}</p>
                    <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">{t.digest}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
          <a
            href="#rank"
            className="mt-4 flex h-9 items-center justify-center whitespace-nowrap rounded-md border border-background-300 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            查看完整今日热议榜
            <i className="ri-arrow-right-line ml-1.5" />
          </a>
        </div>
      </div>
    </section>
  );
}